// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file shifts/list_shifts.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ShiftDetails } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.ListShiftsRequest
 */
export class ListShiftsRequest extends Message<ListShiftsRequest> {
  /**
   * @generated from field: int32 page = 1;
   */
  page = 0;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<ListShiftsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListShiftsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListShiftsRequest {
    return new ListShiftsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListShiftsRequest {
    return new ListShiftsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListShiftsRequest {
    return new ListShiftsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListShiftsRequest | PlainMessage<ListShiftsRequest> | undefined, b: ListShiftsRequest | PlainMessage<ListShiftsRequest> | undefined): boolean {
    return proto3.util.equals(ListShiftsRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ListShiftsResponse
 */
export class ListShiftsResponse extends Message<ListShiftsResponse> {
  /**
   * @generated from field: repeated com.neulink.pharmacy.ShiftDetails shifts = 1;
   */
  shifts: ShiftDetails[] = [];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<ListShiftsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListShiftsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "shifts", kind: "message", T: ShiftDetails, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListShiftsResponse {
    return new ListShiftsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListShiftsResponse {
    return new ListShiftsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListShiftsResponse {
    return new ListShiftsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListShiftsResponse | PlainMessage<ListShiftsResponse> | undefined, b: ListShiftsResponse | PlainMessage<ListShiftsResponse> | undefined): boolean {
    return proto3.util.equals(ListShiftsResponse, a, b);
  }
}

